<template>
    <div class="profile-page">
        <section class="section-profile-cover section-shaped my-0">
            <div class="shape shape-style-1 shape-primary shape-skew alpha-4">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
        </section>
        <section class="section section-lg pt-lg-0 mt--200">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-lg-12">
                        <div class="row row-grid">
                            <div class="col-lg-4">
                                <card class="border-0" shadow body-classes="py-5">
                                    <icon name="fa fa-code" type="default" rounded class="mb-4">
                                    </icon>
                                    <h6 class="text-default text-uppercase">Web Movie Browser</h6>
                                    <p class="description mt-3">Movie browser developped with Vue.js and Firebase. 
                                        (Auth and Firestore). It leverages Cloud Build, triggered on code commit, to build and deploy on Google Cloud Run.
                                    </p>
                                    <div>
                                        <badge type="default" rounded>Vue.js</badge>
                                        <badge type="default" rounded>Firebase</badge>
                                        <badge type="default" rounded>GCP</badge>
                                        <badge type="default" rounded>Cloud Run</badge>
                                        <badge type="default" rounded>Serverless</badge>
                                        <badge type="default" rounded>CI / CD</badge>
                                    </div>
                                </card>
                            </div>
                            <div class="col-lg-4">
                                <card class="border-0" shadow body-classes="py-5">
                                    <icon name="fa fa-code" type="default" rounded class="mb-4">
                                    </icon>
                                    <h6 class="text-default text-uppercase">Personal website</h6>
                                    <p class="description mt-3">This actual web page you're currently 
                                        looking at, developed with Vue.js and the Argon Design System.
                                        Deployed as a static website on Google Cloud Storage via
                                        Firebase Hosting. 
                                    </p>
                                    <div>
                                        <badge type="default" rounded>Vue.js</badge>
                                        <badge type="default" rounded>Firebase</badge>
                                        <badge type="default" rounded>Cloud Storage</badge>
                                        <badge type="default" rounded>static</badge>
                                        <badge type="default" rounded>Serverless</badge>
                                    </div>
                                </card>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
export default {};
</script>
<style>
</style>